<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
  <div class="container-fluid  p-0" *ngIf="!isLoading()">
    <div class="row m-t-xs">
      <div class="col-12">
        <formPlyca [formConfig]="formConfig" #frmReport></formPlyca>
        <!--p-multiSelect
          [options]="profilesModel"
          [(ngModel)]="profileSelected"
          [style]="{ width: '100%' }"
        ></p-multiSelect>-->
      </div>
    </div>
  </div>
</p-scrollPanel>